import { showNotification } from 'containers/NotificationEngine/actions';
import {
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TIMEOUT_NONE,
  NOTIFICATION_TIMEOUT_DEFAULT,
} from 'containers/NotificationEngine/constants';
import { saveInProgress, setForm, setDirty } from 'containers/FormBuilder/actions';
import { addForm as serverAddForm } from 'api/taxi.backend';
import { push } from 'connected-react-router';
import { hasInvalidFormState } from 'containers/FormBuilder/asyncutils';

export const handleSaveFormCreate = async (form, dispatch) => {
  dispatch(saveInProgress(true));
  try {
    const invalidGraph = hasInvalidFormState(form);
    if (invalidGraph.isInvalid) {
      dispatch(showNotification(
        'taxi:graph-invalid',
        NOTIFICATION_TYPE_ERROR,
        invalidGraph.message,
        NOTIFICATION_TIMEOUT_NONE,
        null,
        null
      ));
    } else {
      const response = await serverAddForm(form);
      dispatch(push(`./${response.id}`));
      dispatch(setForm(response));
      dispatch(showNotification(
        'taxi:success-save-form',
        NOTIFICATION_TYPE_SUCCESS,
        'Saved',
        NOTIFICATION_TIMEOUT_DEFAULT,
        null,
        null
      ));
      dispatch(setDirty(false));
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    dispatch(showNotification(
      'taxi:err-save-form',
      NOTIFICATION_TYPE_ERROR,
      'Save failed',
      NOTIFICATION_TIMEOUT_NONE,
      null,
      null
    ));
  }
  dispatch(saveInProgress(false));
};
